import { Card } from '@wajeez-web/components/ui';
import { Content, Server } from '@wajeez-web/core/api-base';
import { Control, UseFormSetValue } from 'react-hook-form';
import { FormTinyMCEInput } from '@wajeez-web/components/form-builder';
interface ContentEntityTextsProps {
  control: Control<Server.CreateContentEntityByTypeIdV2Input> | undefined;
  index: number;
  setValue?: UseFormSetValue<Server.CreateContentEntityByTypeIdV2Input>;
  narratorSelectable?: boolean;
  profileIndex: number;
  isRtl?: boolean;
  contentEntityType?: string;
}

const ContentEntityTexts = ({
  index,
  control,
  narratorSelectable,
  profileIndex,
  isRtl,
  contentEntityType,
}: ContentEntityTextsProps) => {
  // const { field } = useController({
  //   control,
  //   name: `profiles.${profileIndex}.texts.${index}.isDefault`,
  // });
  // const dispatch = useCommonDispatch();
  // const textsData = useContentSelector((s) => s.contentEntityTexts.data ?? []);
  // const saveingText = useContentSelector(
  //   (s) => s.contentEntityTexts.updatingStatus === 'loading'
  // );
  const formContent = () => {
    return (
      <div className="space-y-1">
        <div className="flex justify-end">
          {' '}
          {/* {contentId && (
          <Button
            loading={saveingText}
            Icon={IoSaveOutline}
            color="primary"
            type="text"
            onClick={async () => {
              const response = textsData[index]?.contentEntityId
                ? await dispatch(
                    ContentEntityTextsActions.updateTextAsync({
                      contentEntityTextId:
                        textsData[index].contentEntityTextId,
                      text: control._formValues['texts'][index].text,
                    })
                  )
                : await dispatch(
                    ContentEntityTextsActions.addTextAsync({
                      languageId: 1,
                      contentEntityId: contentId,
                      text: control._formValues['texts'][index].text,
                      isDefault: true,
                    })
                  );
              if (response.meta.requestStatus === 'fulfilled') {
                getTexts && getTexts(contentId || '');
              }
            }}
          />
        )} */}
        </div>
        <div className={`grid grid-cols-${1} gap-3 `}>
          <div className={`md:col-span-${4} col-span-${4}`}>
            <FormTinyMCEInput
              isRtl={isRtl}
              control={control}
              name={`profiles.${profileIndex}.texts.${index}.text`}
              fieldType={{
                fieldType: Content.FieldType.TineMCE,
                fieldOptions: {},
                required: true,
                label: 'Text',
              }}
              contentEntityType={contentEntityType}
            />
          </div>
        </div>
      </div>
    );
  };
  return narratorSelectable ? (
    <Card key={index + ''}>{formContent()}</Card>
  ) : (
    formContent()
  );
};

export default ContentEntityTexts;
